"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldValue = exports.getFieldLabel = exports.getNestedFieldNameSchemaProperty = void 0;
var get_1 = __importDefault(require("lodash/get"));
/**
 * Nested fields should be converted into compatible json schema properties
 * so `personName.firstName` gets transformed into `properties.personName.properties.firstName`
 *
 * Flat field names are kept as a flat string
 *
 * @param fieldName string
 * @returns string
 */
function getNestedFieldNameSchemaProperty(fieldName) {
    return fieldName
        .split('.')
        .map(function (fieldNamePart) { return ['properties', fieldNamePart].join('.'); })
        .join('.');
}
exports.getNestedFieldNameSchemaProperty = getNestedFieldNameSchemaProperty;
/**
 * Returns field label metadata
 *
 * @param fieldName string
 * @param schema Schema
 * @returns string | null | undefined
 */
function getFieldLabel(fieldName, schema) {
    var _a, _b;
    var field = (0, get_1.default)(schema, "" + getNestedFieldNameSchemaProperty(fieldName));
    if (!field) {
        return null;
    }
    return field.inputType === 'checkbox' ? (_a = field.inputMetadata) === null || _a === void 0 ? void 0 : _a.checkboxLabel : (_b = field.inputMetadata) === null || _b === void 0 ? void 0 : _b.label;
}
exports.getFieldLabel = getFieldLabel;
/**
 * Returns field value
 *
 * @param fieldName string
 * @param values any
 * @returns any
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
function getFieldValue(fieldName, values) {
    return (0, get_1.default)(values, fieldName);
}
exports.getFieldValue = getFieldValue;
